import httpHubless from 'hub-http/clients/noPortalApiClient';
export const fetchToken = precedence => httpHubless.post('/two-factor/v1/challenge', {
  data: {
    twoFactorLevel: precedence
  }
});
export const fetchAdminRecoveryEligible = token => httpHubless.get(`/two-factor/v1/admin-recovery/eligible/${token}`);
export const loadTwoFactorRecovery = precedence => fetchToken(precedence).then(({
  token,
  email = ''
}) => fetchAdminRecoveryEligible(token).then(({
  admins,
  eligible,
  shouldForce
}) => ({
  admins,
  eligible,
  email,
  shouldForce,
  token
})));
export const sendAdminRecoveryEmail = token => httpHubless.post('/two-factor/v1/admin-recovery/initiate', {
  data: {
    token
  }
});
export const sendRecoveryEmail = token => httpHubless.post('/two-factor/v1/recovery/email-sends', {
  data: {
    token
  }
});